import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    background: theme.palette.text.white,
    boxSizing: 'border-box',
    padding: theme.spacing(4),
    width: '-webkit-fill-available',
    borderRadius: theme.spacing(1),
  },
  content: {
    display: 'flex',
    width: '-webkit-fill-available',
  },
  wrapperWidth: {
    width: '-webkit-fill-available',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  verticalDivider: {
    width: theme.spacing(0.125),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: theme.spacing(0.5),
    background: theme.palette.dividerV2.main,
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(5),
  },
  funnel: {
    marginTop: theme.spacing(3),
  },
  rootWrapper: { display: 'flex', gap: theme.spacing(3) },
}))
